var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11946 3.79789C4.19949 3.61681 4.37882 3.5 4.57679 3.5H19.4233C19.6206 3.5 19.7995 3.6161 19.8799 3.79635C19.9603 3.9766 19.9271 4.18727 19.7952 4.33411L12.4222 12.5431C12.3277 12.6483 12.1932 12.7086 12.0519 12.709C11.9105 12.7095 11.7756 12.6501 11.6804 12.5456L4.20706 4.3366C4.07379 4.1902 4.03944 3.97896 4.11946 3.79789ZM5.70815 4.5L12.0477 11.4636L18.3021 4.5H5.70815Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0501 11.7089C12.3262 11.7089 12.5501 11.9328 12.5501 12.2089V20C12.5501 20.2761 12.3262 20.5 12.0501 20.5C11.7739 20.5 11.5501 20.2761 11.5501 20V12.2089C11.5501 11.9328 11.7739 11.7089 12.0501 11.7089Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08937 20C8.08937 19.7239 8.31323 19.5 8.58937 19.5H15.5612C15.8373 19.5 16.0612 19.7239 16.0612 20C16.0612 20.2761 15.8373 20.5 15.5612 20.5H8.58937C8.31323 20.5 8.08937 20.2761 8.08937 20Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23666 7.47751C7.23666 7.20137 7.46052 6.97751 7.73666 6.97751H16.4138C16.69 6.97751 16.9138 7.20137 16.9138 7.47751C16.9138 7.75365 16.69 7.97751 16.4138 7.97751H7.73666C7.46052 7.97751 7.23666 7.75365 7.23666 7.47751Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.6489d50825c2845b57a97ffcaada8296.svg";
export { ForwardRef as ReactComponent };